import * as React from 'react';

import { GlanceData, GlancePair, GlanceType, Partner, Region, RelativeTime, StoryType, StudioAppConfig } from 'glance-datatypes';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';

import CircularProgress from 'material-ui/CircularProgress';
import Configuration from '../Configuration';
import DataTables from 'material-ui-datatables';
import DatePicker from 'material-ui/DatePicker';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import RestService from '../RestService';
import Snackbar from 'material-ui/Snackbar';
import Subheader from 'material-ui/Subheader';
import Utils from '../Utils';
import { connect } from 'react-redux';

const TABLE_COLUMNS = [
    {
        key: 'categories',
        label: 'Categories',
    }, {
        key: GlanceType.STORY.toString() + '_' + StoryType.NEWS.toString(),
        label: 'News Story',
        sortable: true,
    },  {
        key: GlanceType.STORY.toString() + '_' + StoryType.FEATURE.toString(),
        label: 'Feature Story',
        sortable: true,
    },{
        key: GlanceType.STORY.toString(),
        label: 'Untagged Story',
        sortable: true,
    }, {
        key: GlanceType.SPONSORED.toString(),
        label: 'Sponsored',
        sortable: true,
    },  {
        key: GlanceType.WALLPAPER.toString(),
        label: 'Wallpaper',
        sortable: true,
    }, {
        key: 'total',
        label: 'Total',
        sortable: true,
    },
  ];

const DAILY_DIGEST_ID = '#daily_digest';

enum CategoryFilter {
    ALL, DAILY_DIGEST, NON_DAILY_DIGEST,
}

interface Props {
    params: any;
    history?: any;
    conf?: Configuration;
    studioAppConfig: StudioAppConfig;
}

interface State {
    data?: GlancePair[];
    partnerFilter?: Partner;
    regionFilter?: Region;
    regionFilters?: Region[];
    filteredGlances?: GlancePair[];
    loadMessage?: string;
    showLoader?: boolean;
    openSnackbar: boolean;
    snackbarMessage: string;
    selectedDate: Date;
    tableData: any[];
    categoryFilter: CategoryFilter;
    localFilterDisplay: string;
}

class Analytics extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            partnerFilter: null,
            regionFilters: null,
            regionFilter: null,
            openSnackbar: false,
            snackbarMessage: '',
            loadMessage: 'Select a partner and region to load',
            selectedDate: new Date(),
            tableData: [],
            categoryFilter: CategoryFilter.ALL,
            localFilterDisplay: 'none',
        };
        this.pushFilterUrl = this.pushFilterUrl.bind(this);
        this.setPartner = this.setPartner.bind(this);
        this.setPartnerAndRegion = this.setPartnerAndRegion.bind(this);
        this.handlePartnerFilterChange = this.handlePartnerFilterChange.bind(this);
        this.handleRegionFilterChange = this.handleRegionFilterChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.matchCategoryFilter = this.matchCategoryFilter.bind(this);
        this.matchCategory = this.matchCategory.bind(this);
        this.fetchGlances = this.fetchGlances.bind(this);
        this.updateTableData = this.updateTableData.bind(this);
        this.closeSnackbar = this.closeSnackbar.bind(this);
        this.handleSortOrderChange = this.handleSortOrderChange.bind(this);
        this.handleCategoryFilterChange = this.handleCategoryFilterChange.bind(this);
        this.getTypeFromData = this.getTypeFromData.bind(this);
    }

    componentWillMount() {
        // TODO: now studioAppConfig will always have a default value this check needs to be changed
        if (!this.props.studioAppConfig) {
            this.props.history.push('/login');
            window.location.reload();
        }
        console.log(this.props.params);
        if (this.props.params && this.props.params.partnerName) {
            const partnerName = this.props.params.partnerName;
            const region = this.props.params.region;

            this.props.studioAppConfig.partners.forEach((partner) => {
                if (partner.name == partnerName) {
                    if (region) {
                        this.setPartnerAndRegion(partner, parseInt(region));
                    } else {
                        this.setPartner(partner);
                    }
                }
            });
        }
    }

    pushFilterUrl(partnerFilter: Partner, regionFilter: Region) {
        console.log(partnerFilter, regionFilter);
        this.props.history.push('/' + this.props.params.role + '/analytics'
                + (partnerFilter ? ('/' + partnerFilter.partnerId + '/' + encodeURIComponent(partnerFilter.name)
                                    + (regionFilter ? ('/' + regionFilter + '/' + Utils.getReadableRegionName(regionFilter)) : ''))
                                : ''
                ),
            );
    }

    setPartner(value: Partner) {
        if (value == null) {
            this.setState({
                ...this.state,
                partnerFilter: value,
                regionFilters: null,
                regionFilter: null,
                loadMessage: 'Select a partner and region',
                data: null,
            });
        } else {
            const filteredRegions : Region[] = [];
            this.props.studioAppConfig.partnerMetas.forEach((item) => {
                if (item.partnerId == value.partnerId) {
                    item.supportedRegions.forEach((item) => {
                        filteredRegions.push(item);
                    });
                }
            });
            if (filteredRegions.length == 1) {
                this.pushFilterUrl(value, filteredRegions[0]);
                this.setPartnerAndRegion(value, filteredRegions[0]);
            } else {
                    this.setState({
                        ...this.state,
                        partnerFilter: value,
                        regionFilters: filteredRegions,
                        regionFilter: null,
                        loadMessage: 'Select a region',
                        data: null,
                    });
            }

        }
    }

    setPartnerAndRegion(partner: Partner, region: Region) {
        const filteredRegions : Region[] = [];
        let partnerAutoApprove: boolean = false;
        let isSponsoredEnabled: boolean = false;
        if (partner) {
            this.props.studioAppConfig.partnerMetas.forEach((item) => {
                if (item.partnerId == partner.partnerId) {
                    partnerAutoApprove = item.autoApprove;
                    isSponsoredEnabled = item.isSponsoredEnabled ? item.isSponsoredEnabled : false;
                    item.supportedRegions.forEach((item) => {
                        filteredRegions.push(item);
                    });
                }
            });
        }
        if (partner == null || !region) {
            this.setState({
                    ...this.state,
                    loadMessage: 'Select a partner and region',
                    partnerFilter: null,
                    regionFilter: null,
                    regionFilters: filteredRegions,
                    data: null,
            });
            return;
        } else {
            this.setState({
                    ...this.state,
                    partnerFilter: partner,
                    regionFilter: region,
                    regionFilters: filteredRegions,
                    loadMessage: 'Loading live glances for ' + partner.name + ' in ' +  Utils.getReadableRegionName(region) + ' ...',
                    showLoader: true,
                    data: null,
                    localFilterDisplay: 'block',
            });
            this.fetchGlances(partner, region, this.state.selectedDate);
        }
    }

    fetchGlances(partner, region, date: Date) {
        let that = this;
        let selectedDate = date;
        let nextDate = new Date(selectedDate);
        nextDate.setDate(selectedDate.getDate() + 1);
        let startAtLessThan = new RelativeTime({
            year: nextDate.getFullYear(),
            month: nextDate.getMonth() + 1,
            date: nextDate.getDate(),
            hour: 0,
            minute: 0,
        });
        let startAtGreaterThan = new RelativeTime({
            year: selectedDate.getFullYear(),
            month: selectedDate.getMonth() + 1,
            date: selectedDate.getDate(),
            hour: 0,
            minute: 0,
        });
        RestService.getLiveGlancesBetweenTime(partner, region, startAtGreaterThan, startAtLessThan,
            (data: GlancePair[]) => {
            if (data == null) {
                that.updateTableData({
                    ...that.state,
                    snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.',
                    openSnackbar: true,
                    loadMessage: 'Loading failed. Try refresh or Contant Glance Support.',
                    showLoader: false,
                    data: null,
                });
            } else {
                that.updateTableData({
                        ...that.state,
                        data: data,
                        snackbarMessage: 'Glances loaded',
                        openSnackbar: true,
                        loadMessage: null,
                        showLoader: false,
                });
            }
        });
    }

    handleSortOrderChange = (key, order) => {
        let sign = 1 * (order == 'desc' ? -1 : 1);
        let tableData = this.state.tableData;
        tableData.sort((a, b) => {
            return (sign * (a[key] - b[key]));
        });
        this.setState({
            ...this.state,
            tableData,
        });
    }

    handleDateChange = (event, date: Date) => {
        this.setState({
            ...this.state,
            selectedDate: date,
            data: null,
            loadMessage: 'Loading live glances for ' + this.state.partnerFilter.name
                + ' in ' +  Utils.getReadableRegionName(this.state.regionFilter) + ' ...',
            showLoader: true,
        });
        this.fetchGlances(this.state.partnerFilter, this.state.regionFilter, date);
      }

    handlePartnerFilterChange(event : any, index : number, value: Partner) {
        this.pushFilterUrl(value, this.state.regionFilter);
        window.location.reload();
    }

    handleRegionFilterChange(event : any, index : number, value: Region) {
        this.pushFilterUrl(this.state.partnerFilter, value);
        this.setPartnerAndRegion(this.state.partnerFilter, value);
    }

    handleCategoryFilterChange(event : any, index : number, value: string) {
        let that = this;
        that.updateTableData({
            ...that.state,
            categoryFilter: CategoryFilter[value],
        });
    }

    matchCategoryFilter(currentCategoryIds: string[], categoryFilter: CategoryFilter) {
        let result = false;
        switch (categoryFilter) {
            case CategoryFilter.NON_DAILY_DIGEST:
                result = currentCategoryIds.indexOf(DAILY_DIGEST_ID) == -1;
                break;
            case CategoryFilter.DAILY_DIGEST:
                result = currentCategoryIds.indexOf(DAILY_DIGEST_ID) > -1;
                break;
            case CategoryFilter.ALL:
                result = true;
                break;
        }
        return result;
    }

    matchCategory(currentCategoryIds: string[], requiredCategoryId: string) {
        return currentCategoryIds != null && currentCategoryIds.indexOf(requiredCategoryId) > -1;
    }

    getTypeFromData(data: GlanceData) {
        let type = data.type.toString();
        if (data.type == GlanceType.STORY && data.storyType != null) {
            if (data.storyType != null) {
                type += ('_' + data.storyType.toString());
            }
        }
        return type;
    }

    updateTableData(newState: State) {
        console.log(newState);
        if (newState.data) {
            let tableData = [];
            this.props.studioAppConfig.categories.forEach((category) => {
                let typeCount = {};
                let catTotal : number = 0;
                newState.data.forEach((pair) => {
                    if (this.matchCategoryFilter(pair.data.categoryIds, newState.categoryFilter)
                        && this.matchCategory(pair.data.categoryIds, category.id)) {
                        let glanceType = this.getTypeFromData(pair.data);
                        glanceType in typeCount ? typeCount[glanceType]++ : typeCount[glanceType] = 1;
                        catTotal++;
                    }
                });

                let tableRow  = {};
                for (let key in typeCount) {
                    tableRow[key] = typeCount[key];
                }
                tableRow['categories'] = category.displayName;
                tableRow['total'] = catTotal;
                if (!(GlanceType.WALLPAPER.toString() in tableRow)) {
                    tableRow[GlanceType.WALLPAPER.toString()] = 0;
                }
                if (!(GlanceType.STORY.toString() in tableRow)) {
                    tableRow[GlanceType.STORY.toString()] = 0;
                }
                if (!(GlanceType.SPONSORED.toString() in tableRow)) {
                    tableRow[GlanceType.SPONSORED.toString()] = 0;
                }
                if (!((GlanceType.STORY.toString() + '_' + StoryType.NEWS.toString()) in tableRow)) {
                    tableRow[GlanceType.STORY.toString() + '_' + StoryType.NEWS.toString()] = 0;
                }
                if (!((GlanceType.STORY.toString() + '_' + StoryType.FEATURE.toString()) in tableRow)) {
                    tableRow[GlanceType.STORY.toString() + '_' + StoryType.FEATURE.toString()] = 0;
                }
                tableData.push(tableRow);

            });
            let tableRow  = {};
            tableRow['categories'] = 'Any';
            tableRow['total'] = newState.data.length;
            tableRow[GlanceType.WALLPAPER.toString()] = 0;
            tableRow[GlanceType.STORY.toString()] = 0;
            tableRow[GlanceType.STORY.toString() + '_' + StoryType.NEWS.toString()] = 0;
            tableRow[GlanceType.STORY.toString() + '_' + StoryType.FEATURE.toString()] = 0;
            tableRow[GlanceType.SPONSORED.toString()] = 0;
            tableRow['total'] = 0;
            newState.data.forEach((pair) => {
                if (this.matchCategoryFilter(pair.data.categoryIds, newState.categoryFilter)) {
                    tableRow[this.getTypeFromData(pair.data)]++;
                    tableRow['total']++;
                }
            });
            tableData.push(tableRow);
            this.setState({
                ...newState,
                tableData: tableData,
            });
        } else {
            this.setState({
                ...newState,
                tableData: null,
            });
        }
    }

    closeSnackbar() {
        this.setState({
            ...this.state,
            openSnackbar: false,
        });
    }

    render() {
        return (
            <div>
                {
                    !this.state.partnerFilter ?
                    <Toolbar style={{marginTop : '2%'}}>
                        <ToolbarGroup firstChild={true}>
                            <DropDownMenu value={this.state.partnerFilter}
                                onChange={this.handlePartnerFilterChange}  >
                                <MenuItem value={null} primaryText={'Click here select to Partner'} key={'empty'}></MenuItem>
                                {
                                    this.props.studioAppConfig.partners.map((item, index) => {
                                        return (
                                            <MenuItem value={item} primaryText={item.name} key={item.partnerId}/>
                                        );
                                    })
                                }
                            </DropDownMenu>
                        </ToolbarGroup>
                    </Toolbar>
                    :
                    <Toolbar style={{marginTop : '2%'}}>
                        <ToolbarGroup firstChild={true}>
                            <ToolbarTitle text='Filters' style={{marginLeft: '24px'}}/>
                            <ToolbarSeparator />
                            <DropDownMenu value={this.state.partnerFilter}
                                onChange={this.handlePartnerFilterChange}  >
                                <MenuItem value={null} primaryText={'Select Partner'} key={'empty'}></MenuItem>
                                {
                                    this.props.studioAppConfig.partners.map((item, index) => {
                                        return (
                                            <MenuItem value={item} primaryText={item.name} key={item.partnerId}/>
                                        );
                                    })
                                }
                            </DropDownMenu>

                            <DropDownMenu value={this.state.regionFilter}
                                onChange={this.handleRegionFilterChange}>
                                <MenuItem value={null} primaryText={'Select Region'} key='empty'></MenuItem>
                                {
                                    this.state.regionFilters.map((item, index) => {
                                        return (
                                            <MenuItem value={item} primaryText={Utils.getReadableRegionName(item)} key={index}/>
                                        );
                                    })
                                }
                            </DropDownMenu>

                            <DatePicker
                                style={{display: this.state.localFilterDisplay}}
                                value={this.state.selectedDate}
                                onChange={this.handleDateChange}
                            />

                            <DropDownMenu value={CategoryFilter[this.state.categoryFilter]}
                                onChange={this.handleCategoryFilterChange}
                                style={{display: this.state.localFilterDisplay}}>
                                {
                                    Object.keys(CategoryFilter).filter(k =>
                                            typeof CategoryFilter[k as any] === 'number').map((key, index) => {
                                        return (<MenuItem value={key} primaryText={key} key={key}/>);
                                    })
                                }
                            </DropDownMenu>
                        </ToolbarGroup>
                    </Toolbar>
                }

                {
                    this.state.data ?
                    (
                        this.state.tableData && this.state.tableData.length > 0 ?
                            <DataTables
                                height={'auto'}
                                selectable={false}
                                showRowHover={true}
                                columns={TABLE_COLUMNS}
                                data={this.state.tableData}
                                showCheckboxes={false}
                                onSortOrderChange={this.handleSortOrderChange}
                                page={1}
                                count={100}
                            />
                        : <h1>No glances for selected filters</h1>
                    ) : <div>
                            <Subheader>
                                <h1>
                                    {
                                        this.state.showLoader ? <CircularProgress /> : ''
                                    }
                                    {this.state.loadMessage}
                                </h1>
                            </Subheader>
                        </div>
                }
                <Snackbar open={this.state.openSnackbar} message={this.state.snackbarMessage} onRequestClose={this.closeSnackbar} autoHideDuration={2000} />
            </div>
        );

    }
}


const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};


export default connect(mapStateToProps)(Analytics);



// WEBPACK FOOTER //
// ./src/components/Analytics.tsx